import { render, staticRenderFns } from "./RequestsStats.vue?vue&type=template&id=70d10284&scoped=true&"
import script from "./RequestsStats.vue?vue&type=script&lang=js&"
export * from "./RequestsStats.vue?vue&type=script&lang=js&"
import style0 from "./RequestsStats.vue?vue&type=style&index=0&id=70d10284&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d10284",
  null
  
)

export default component.exports